import React from 'react'
import './FooterMain.css'
import LogoBig from '../images/svg/v8logobig.svg'
import DecoIco1 from '../images/svg/decoIco1.svg'
import DecoIco2 from '../images/svg/decoIco2.svg'
import DecoIco3 from '../images/svg/decoIco3.svg'
import FiveStars from '../images/webp/5Starsv2.webp'
import IconFrameS from './IconFrameS'
import Newsletterform from './Newsletterform'

function FooterMain() {
    return (
        <div className='footer-main-container'>
            <div className='col-one'>
                <img src={LogoBig} alt='Marketing v8 logo' />
                <p>We build intelligent growth systems that <br />automate acquisition, conversion, and <br />performance.
                    Less manual work.
                    <br />More scalable results.</p>

            </div>
            <div className='col-two'>
                <div className='col-title'>
                    <h4>STAY AHEAD</h4>
                </div>
                <div className='col-data'>
                    <p>Get practical insights on AI, automation, and scalable growth infrastructure - straight to your inbox.</p>
                    <Newsletterform />
                </div>

            </div>
            <div className='col-three'>
                <div className='col-title'>
                    <h4>Contact</h4>
                </div>
                <div className='col-data'>
                    <p>Rokocin 4D<br />
                        83-200 Rokocin<br />
                        Poland</p>
                    <a className='contact-link' href='tel:+48535959510'>+48 535 959 510</a>

                    <a className='contact-link' href='mailto:office@marketingv8.co'>office@marketingv8.co</a>
                </div>

            </div>
            <div className='deco-icons-all'>
                <IconFrameS
                    icon={DecoIco1}
                    text='AI STRATEGY'
                    width='fit-content'
                />


                <IconFrameS
                    icon={DecoIco2}
                    text='AUTOMATION'
                    width='fit-content'
                />


                <IconFrameS
                    icon={DecoIco3}
                    text='GROWTH'
                    width='fit-content'
                />

            </div>
            <div className='others-about-us'>
                <a href='https://www.designrush.com/agency/content-marketing/california/san-francisco' target='_blank' rel='noreferrer'>
                    <img src={FiveStars} className='five-stars-img' alt='5 stars by designrush' />
                </a>
            </div>
        </div>
    )
}

export default FooterMain